'use client';

import dynamic from 'next/dynamic';
import { useDevice } from '@/context/device-context';

const StickyBox = dynamic(() => import('@/components/sticky-box/sticky-box').then(mod => mod.StickyBox));

export const StickyBoxContainer = () => {
  const { deviceType } = useDevice();

  return deviceType === 'desktop' && <StickyBox />;
};
